import React, { useState, useEffect } from 'react'
import SEO from '../../seo'
import Container from '../../UI/Container/Container'
import Heading from '../../UI/Heading/Heading'
import SearchInput from '../../UI/SearchInput/SearchInput'
import classes from '../PrivacyPolicy/PrivacyPolicy.module.css'
import vocabularyData from '../../../../data/vocabulary/vocabularyReduced.json'
import QuestionsData from '../../../../data/questions/questionsShuffled.json'
import { stringToVocabularyUrl } from '../../../utils/utils'

export default props => {
  const [vocabulary, setVocabulary] = useState(Object.keys(vocabularyData))
  const [questionLinks, setQuestionLinks] = useState([])
  const { data, termTitle, termKeywords, termDescription } = props

  useEffect(() => {
    if (data) {
      setVocabulary([data.item])
    }
  }, [data])

  useEffect(() => {
    if (vocabulary.length === 1) {
      const query = vocabulary[0]
        .split(' ')
        .slice(0, 2)
        .join(' ')
        .toLowerCase()

      const questions = Object.values(QuestionsData)
        .filter(
          question =>
            question.body.toLowerCase().includes(`\\b${query}(es|s)?\\b`) ||
            Object.values(question.answers)
              .join('')
              .toLowerCase()
              .includes(query)
        )
        .map(question => question.url)

      setQuestionLinks(questions)
    } else {
      setQuestionLinks([])
    }
  }, [vocabulary])

  const onSearchChange = event => {
    const query = event.target.value.toLocaleLowerCase()

    setVocabulary(
      Object.keys(vocabularyData).filter(item =>
        item.toLocaleLowerCase().includes(query)
      )
    )
  }

  return (
    <Container>
      <SEO
        title={
          termTitle ? termTitle : 'PMP Vocabulary | PMP Terms | PMP Glossary'
        }
        keywords={
          termKeywords
            ? termKeywords
            : [
                `PMP`,
                `PMP Vocabulary`,
                `PMP Glossary`,
                `Project Management Terms`
              ]
        }
        description={
          termDescription
            ? termDescription
            : 'Learn PMP Vocabulary, Must-Know PMP Terms, Complete PMP Glossary'
        }
      ></SEO>
      <Heading text="VOCABULARY" />
      <SearchInput onChange={onSearchChange} value={data ? data.item : null} />
      <p className={classes.Heading_1}>
        <strong>Vocabulary items:</strong>
      </p>
      {vocabulary.map(item => (
        <div style={{ marginBottom: '7px', textAlign: 'justify' }} key={item}>
          <span
            className={classes.TableOfContent}
            key={`vocabulary_item_${item}`}
          >
            <a href={stringToVocabularyUrl(item)}>{item}</a>
          </span>
          <span>
            {' '}
            -{' '}
            {data
              ? data.item === item && vocabulary.length === 1
                ? data.definition
                : vocabularyData[item]
              : vocabularyData[item]}
          </span>
        </div>
      ))}
      {questionLinks.length > 0 ? (
        <div>
          <br />
          <p className={classes.Heading_1}>
            <strong>Questions with this term:</strong>
          </p>
        </div>
      ) : null}
      {questionLinks.map((link, i) => (
        <p className={classes.TableOfContent} key={link}>
          <a href={link}>
            {i + 1}.{' '}
            {link.charAt(0).toUpperCase() + link.slice(1).replace(/-/g, ' ')}
          </a>
        </p>
      ))}
    </Container>
  )
}
